import gql from 'graphql-tag'

import { PropertyValues, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { PageView } from '@operato/shell'
import { i18next, localize } from '@operato/i18n'
import { client } from '@operato/graphql'

import './data-ooc-view.js'

@customElement('data-ooc-page')
export class DataOocViewPage extends localize(i18next)(PageView) {
  static styles = [
    css`
      :host {
        display: flex;
      }

      data-ooc-view {
        flex: 1;
      }

      @media print {
        :host {
          display: block;
          overflow: visible;
        }
      }
    `
  ]

  @property({ type: Object }) dataOoc?: any

  get context() {
    return {
      title: i18next.t('title.data-ooc view'),
      help: 'dataset/data-ooc',
      actions: []
    }
  }

  render() {
    return html` <data-ooc-view .dataOoc=${this.dataOoc}></data-ooc-view> `
  }

  updated(changes: PropertyValues<this>) {}

  pageUpdated(changes: any, lifecycle: any, before: any) {
    if (this.active) {
      /*
       * this page is activated
       */
      this.fetchOoc(lifecycle.resourceId)
    } else {
      /* this page is deactivated */
    }
  }

  async fetchOoc(id: string) {
    const response = await client.query({
      query: gql`
        query ($id: String!) {
          dataOoc(id: $id) {
            id
            name
            description
            useCase
            dataSet {
              id
              name
              monitorType
              monitorView
            }
            key01
            key02
            key03
            key04
            key05
            partitionKeys
            dataItems {
              name
              description
              active
              hidden
              tag
              group
              subgroup
              type
              unit
              options
              quota
              spec
              stat
            }
            data
            rawData
            judgment
            ooc
            oos
            state
            history
            workDate
            workShift
            correctiveInstruction
            correctiveAction
            reviewedAt
            reviewer {
              id
              name
            }
            correctedAt
            corrector {
              id
              name
            }
            updater {
              id
              name
            }
            updatedAt
            collectedAt
            reviewActivityInstance {
              ...ActivityInstanceFragment
            }
            resolveActivityInstance {
              ...ActivityInstanceFragment
            }
          }
        }

        fragment ActivityInstanceFragment on ActivityInstance {
          activityThreads {
            assignee {
              name
            }
            output
            activityApprovals {
              judgment
              approver {
                name
              }
              comment
              createdAt
              updatedAt
              terminatedAt
            }
            activityThreadHistories {
              transaction
              reason
              updater {
                name
              }
              updatedAt
              state
              output
            }
          }
        }
      `,
      variables: {
        id
      }
    })

    this.dataOoc = response.data.dataOoc
  }
}
